export default __webpack_public_path__ + "static/media/la-yogi.5009deca.jpg";